import {useEffect,useRef} from 'react';
export default function useDriverPolling(callback,enabled,interval=5000,account=''){
 const latest=useRef(callback);latest.current=callback;
 useEffect(()=>{
  if(!enabled||typeof document==='undefined')return;
  let stopped=false,timer,running=false;let delay=interval;
  const tick=async()=>{
   if(stopped||document.hidden||running)return;
   running=true;
   try{await latest.current();delay=interval;}catch{delay=Math.min(delay*2,60000);}finally{running=false;}
   if(!stopped&&!document.hidden)timer=setTimeout(tick,delay);
  };
  const visible=()=>{clearTimeout(timer);if(!document.hidden&&!running)tick();};
  document.addEventListener('visibilitychange',visible);tick();
  return()=>{stopped=true;clearTimeout(timer);document.removeEventListener('visibilitychange',visible);};
 },[enabled,interval,account]);
}
